// extracted by mini-css-extract-plugin
export default {"wrapper":"Roller_wrapper__BsF2v","roller":"Roller_roller__sDEN+"};